import React from 'react';
import { CaseStudyDetail } from '../components/CaseStudyDetail';
import { FeatureVideo } from '../components/FeatureVideo';
import { caseStudies } from '../data/caseStudies';
import { amexImages, amexIntro, amexMetrics, amexSections } from '../data/amexCaseStudy';
type AmexCaseStudyProps = {
  heroMedia?: 'video' | 'carousel';
};
export function AmexCaseStudy({
  heroMedia = 'video'
}: AmexCaseStudyProps) {
  const card = caseStudies.find(s => s.id === 'amex');
  const videoSrc = card?.videos?.[0];
  const media = heroMedia === 'video' && videoSrc && card ? <FeatureVideo src={videoSrc} poster={card.images[0]} background={card.background} label="American Express corporate card application walkthrough" data-id="element-127" data-mp="1cgxi91ae6dz3" /> : undefined;
  return <CaseStudyDetail id="amex" intro={amexIntro} images={amexImages} metrics={amexMetrics} sections={amexSections} media={media} data-id="element-128" data-mp="k04qnokqfzdp" />;
}